import { cmcRateLimiter } from "./cmc-rate-limiter";
import { getTokenMeta } from "./get-token-meta";
import { getTokenPrice } from "./get-token-price";

export const CmcClient = {
  getTokenMeta,
  getTokenPrice,

  cmcRateLimiter,
};
